import { SOCIALS, CONTACT_EMAILS, NAV_LINKS } from "@/content";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-ink text-paper px-6 md:px-12 pt-20 md:pt-28 pb-10">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 border-b border-paper/15 pb-14">
          <div className="md:col-span-5">
            <p data-testid="footer-wordmark" className="font-spartan font-extrabold uppercase display-type leading-[0.9] text-4xl md:text-5xl">
              David<br />Rosenblum
            </p>
            <p className="mt-4 text-xs tracking-[0.3em] uppercase text-paper/50">
              Worship Leader + Speaker
            </p>
          </div>

          <nav aria-label="Footer" className="md:col-span-3">
            <p className="text-[11px] font-semibold tracking-[0.25em] uppercase text-paper/50 mb-5">Navigate</p>
            <ul className="space-y-3">
              {NAV_LINKS.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    data-testid={`footer-nav-${link.label.toLowerCase()}`}
                    className="text-sm text-paper/80 hover:text-paper transition-colors duration-300"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div className="md:col-span-4">
            <p className="text-[11px] font-semibold tracking-[0.25em] uppercase text-paper/50 mb-5">Connect</p>
            <ul className="space-y-3">
              <li>
                <a href={SOCIALS.spotify} target="_blank" rel="noopener noreferrer" data-testid="footer-social-spotify" className="inline-flex items-center gap-3 text-sm text-paper/80 hover:text-paper transition-colors duration-300">
                  <img src="https://cdn.simpleicons.org/spotify/F4F0E8" alt="" aria-hidden="true" loading="lazy" className="w-4 h-4" />
                  Spotify
                </a>
              </li>
              <li>
                <a href={SOCIALS.apple} target="_blank" rel="noopener noreferrer" data-testid="footer-social-apple" className="inline-flex items-center gap-3 text-sm text-paper/80 hover:text-paper transition-colors duration-300">
                  <img src="https://cdn.simpleicons.org/applemusic/F4F0E8" alt="" aria-hidden="true" loading="lazy" className="w-4 h-4" />
                  Apple Music
                </a>
              </li>
              <li>
                <a href={SOCIALS.youtube} target="_blank" rel="noopener noreferrer" data-testid="footer-social-youtube" className="inline-flex items-center gap-3 text-sm text-paper/80 hover:text-paper transition-colors duration-300">
                  <img src="https://cdn.simpleicons.org/youtube/F4F0E8" alt="" aria-hidden="true" loading="lazy" className="w-4 h-4" />
                  YouTube
                </a>
              </li>
              <li>
                <a href={SOCIALS.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-social-instagram" className="inline-flex items-center gap-3 text-sm text-paper/80 hover:text-paper transition-colors duration-300">
                  <img src="https://cdn.simpleicons.org/instagram/F4F0E8" alt="" aria-hidden="true" loading="lazy" className="w-4 h-4" />
                  Instagram
                </a>
              </li>
              <li>
                <a href={SOCIALS.facebook} target="_blank" rel="noopener noreferrer" data-testid="footer-social-facebook" className="inline-flex items-center gap-3 text-sm text-paper/80 hover:text-paper transition-colors duration-300">
                  <img src="https://cdn.simpleicons.org/facebook/F4F0E8" alt="" aria-hidden="true" loading="lazy" className="w-4 h-4" />
                  Facebook
                </a>
              </li>
            </ul>
            <p className="text-[11px] font-semibold tracking-[0.25em] uppercase text-paper/50 mt-8 mb-3">Booking</p>
            <ul className="space-y-2">
              {CONTACT_EMAILS.map((email) => (
                <li key={email}>
                  <a href={`mailto:${email}`} data-testid={`footer-email-${email === CONTACT_EMAILS[0] ? "admin" : "david"}`} className="text-sm text-paper/80 hover:text-paper transition-colors duration-300">
                    {email}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-paper/40">© {new Date().getFullYear()} David Rosenblum. All rights reserved.</p>
          <a href="#top" data-testid="footer-back-to-top" className="text-xs tracking-[0.22em] uppercase text-paper/50 hover:text-paper transition-colors duration-300">
            Back to top ↑
          </a>
        </div>
      </div>
    </footer>
  );
}
